<template>
  <el-dialog
    title="切换编辑模式"
    :visible.sync="visible"
    @close="dialogClose"
    width="60%"
    class="changeEditType"
  >
    <i class="el-icon-warning"></i>切换至文本编辑模式会导致图片、填空等
    <strong>富文本信息</strong>以及
    <strong>逻辑设置</strong>丢失，您确认要继续切换到文本编辑模式吗？
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="confirmTextEditing">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { MSG } from "../utils/utils";

export default {
  name: "shareDialog",
  data() {
    return {
      visible: false
    };
  },
  props: ["dialogShow"],
  watch: {
    shareSurvey: {
      deep: true,
      handler(val) {
        this.handleShare(val);
      }
    },
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    }
  },
  methods: {
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    confirmTextEditing(){
      this.$emit("update:dialogShow", false);
      this.$emit("confirm");
    }
  }
};
</script>


<style lang="scss" scoped>
  .changeEditType {
    strong {
      color: #f0614e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editDialog.vue